import { Box, styled } from '@mui/material';
import React from 'react'
import './SettingsPage.css';
const SettingsPage = () => {
  const Container = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    // background:'radial-gradient(at 60% 60%, #90284E,#40033C, #1F021C)',
    // background: 'radial-gradient(circle at top left, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), radial-gradient(circle at bottom right, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), #000000',
    background: 'radial-gradient(circle at top left, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), radial-gradient(circle at bottom right, rgba(234, 61, 255, 0.4), rgba(0, 0, 0, 0) 40%), #000000',
    flexDirection: 'column',
  });
  return (
    <div className="background">
      {/* Other content can go here */}
    </div>
  )
}

export default SettingsPage